import { render } from "./IconBar.vue?vue&type=template&id=52b7d1e2"
import script from "./IconBar.vue?vue&type=script&lang=js"
export * from "./IconBar.vue?vue&type=script&lang=js"

import "./IconBar.vue?vue&type=style&index=0&id=52b7d1e2&lang=css"

import exportComponent from "/Users/brian/Documents/web-projects/clients/andy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__